import * as React from "react";
import Spinner from '../../common/components/spinner/spinner';
import Translate from '../../common/functions/translate';
import { UserModel } from '../../models/user/userModel';
import { Link } from "react-router-dom";
import * as HelperFunctions from "../../common/functions/helperFunctions";
import LoginService from '../../services/loginService';
import MailService from '../../services/mailService';
import * as Constants from '../../common/constants';
import { EmailDataModel } from '../../models/emailDataModel';
import * as EmailFunctions from '../../common/functions/emailFunctions';
import Button from '@material-ui/core/Button';
import Growl from '../../common/components/alertMessage/growl';
import TextField from '@material-ui/core/TextField';
import Checkbox from '@material-ui/core/Checkbox';
import GrowlContent from '../../common/components/alertMessage/growlContent';

interface IProps {
  history: any,
  location: any
}

interface IState {
  isLoading: boolean;
  user: UserModel;
  mode: string;
  passError: boolean;
  confPassError: boolean;
  emailError: boolean;
}

class CreateNewAccountComponent extends React.Component<IProps, IState> {

  loginService = new LoginService();
  mailService = new MailService();
  growl: any;

  // min 8 characters, 1 alpha lowercase, 1 alpha uppercase, 1 number and 1 special
  passwordStrongRegex = new RegExp("^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[!@#\$%\^&\*])(?=.{8,})");
  // min 6 characters, 1 alpha and 1 number
  passwordMediumRegex = new RegExp("^(((?=.*[a-z])(?=.*[A-Z]))|((?=.*[a-z])(?=.*[0-9]))|((?=.*[A-Z])(?=.*[0-9])))(?=.{6,})");

  constructor(props: IProps) {
    super(props);

    this.state = {
      isLoading: false,
      user: new UserModel(),
      mode: 'createNewAccount',
      passError: false,
      confPassError: false,
      emailError: false
    };
  }

  componentDidMount() {
    let confirmCodeUrl = HelperFunctions.getURLParameter('confirmCode');

    if (confirmCodeUrl) {
      let confirmCode = decodeURIComponent(confirmCodeUrl + '');
      this.validateConfirmCode(confirmCode);
    }
  }

  handleChange = (key, value) => {
    const user: UserModel = { ...this.state.user };
    user[key] = value;
    this.setState({ user: { ...user } });

    if (key == 'email') {
      this.setState({ emailError: !HelperFunctions.validateEmail(user.email) });
    }

    if (key == 'password') {
      this.setState({ passError: !this.passwordMediumRegex.test(value) });
    }

    if (key == 'confirmPassword') {
      this.setState({ confPassError: user.password != user.confirmPassword });
    }
  };

  handleKeyPress = (e) => {
    if (e.key === 'Enter') {
      this.handleCreateButton(e);
    }
  }

  isValidAddEditForm() {
    let message = '';

    const { user } = this.state;

    if (!user.email || user.email.trim() == '') {
      message += Translate('Please enter Email') + '. ';
    } else {
      if (!HelperFunctions.validateEmail(user.email)) {
        message += Translate('Please enter valid Email') + '. ';
      }
    }

    if (!user.name || user.name.trim() == '') {
      message += Translate('Please enter Name') + '. ';
    }

    if (!user.password || user.password.trim() == '') {
      message += Translate('Please enter Password') + '. ';
    }

    if (!user.confirmPassword || user.confirmPassword.trim() == '') {
      message += Translate('Please enter Confirm Password') + ". ";
    }

    if (user.password && user.password.trim() != '' &&
      user.confirmPassword && user.confirmPassword.trim() != '' &&
      user.password != user.confirmPassword) {
      message += Translate('Password and Confirm Password are different') + ". ";
    }

    if (user.password && !this.passwordMediumRegex.test(user.password)) {
      message += Translate('Password must be at least 6 characters and contain at least 1 alphabetical and 1 numeric character') + ". ";
    }

    if (!user.acceptPersonalDataPrivatePolicy) {
      message += Translate('Please accept personal data private Policy') + '. ';
    }

    if (message != '') {
      this.growl.show({ severity: 'error', summary: message });
    }

    return message == '';
  }

  handleCreateButton = event => {
    event.preventDefault();

    if (!this.isValidAddEditForm()) return;

    this.setState({
      isLoading: true
    });

    const user = this.state.user;

    this.loginService.createUser(user).then(
      (result: any) => {
        this.setState({
          isLoading: false,
          mode: result == 1 ? 'successRegistration' : 'successRegistrationWithEmail'
        });
      })
      .catch(error => {
        this.growl.show({ severity: 'error', summary: error.message });
        this.setState({
          isLoading: false
        });
      });
  }

  validateConfirmCode(confirmCode) {
    this.setState({
      isLoading: true
    });

    this.loginService.validateAndActivate(confirmCode).then(
      (data: any) => {
        if (data) {
          this.setState({
            isLoading: false,
            mode: 'validConfirmCode'
          })
        }
      })
      .catch(error => {
        this.setState({
          isLoading: false,
          mode: 'notValidConfirmCode'
        });
      });
  }

  public render() {
    const { isLoading, user, mode, passError, confPassError, emailError } = this.state;

    const registrationFormHtml =
      <>
        <div className="p-g p-fluid">
          <div className="p-g-12 p-md-12">
            <TextField
              autoComplete="off"
              required
              error={emailError}
              name="email"
              label={Translate('Email')}
              type="email"
              value={user && user.email ? user.email : ""}
              onChange={(e) => this.handleChange('email', e.target['value'])}
              helperText={Translate("Please enter a valid e-mail address.")}
            />
          </div>
          <div className="p-g-12 p-md-12">
            <TextField
              autoComplete="off"
              required
              name="name"
              label={Translate('Name')}
              type="text"
              value={user && user.name ? user.name : ""}
              onChange={(e) => this.handleChange('name', e.target['value'])}
              helperText={Translate("Please enter personal name.")}
            />
          </div>
          <div className="p-g-12 p-md-12">
            <TextField
              autoComplete="off"
              required
              error={passError}
              type="password"
              name="password"
              label={Translate('Password')}
              onKeyPress={this.handleKeyPress}
              onChange={(e) => this.handleChange('password', e.target['value'])}
              value={user && user.password ? user.password : ""}
              helperText={Translate("6 characters or more, at least 1 alphabetical and 1 numeric.")}
            />
          </div>
          <div className="p-g-12 p-md-12">
            <TextField
              autoComplete="off"
              required
              error={confPassError}
              type="password"
              name="confirmPassword"
              label={Translate('Confirm Password')}
              onKeyPress={this.handleKeyPress}
              onChange={(e) => this.handleChange('confirmPassword', e.target['value'])}
              value={user && user.confirmPassword ? user.confirmPassword : ""}
              helperText={Translate("Please enter password again.")}
            />
          </div>
          <div className="p-g-12 p-md-12">
            <Checkbox
              onChange={() => user.acceptPersonalDataPrivatePolicy = !user.acceptPersonalDataPrivatePolicy}
              value={user.acceptPersonalDataPrivatePolicy + ''}
              color="primary"
            />
            <label style={{ padding: '10px 0 0 10px' }}>
              {Translate('Accept')}
              <Link to='/personal-data-policy'> {Translate('personal data protection policy')}</Link>
            </label>
          </div>
        </div>
        <div style={{ padding: '10px 9px' }}>
          <Button variant="contained" size="medium" color='primary' onClick={this.handleCreateButton}
            style={{ marginBottom: '15px' }}>
            {Translate('Create')}
          </Button>
        </div>
      </>

    const successRegistrationHtml =
      <>
        <div>
          <GrowlContent variant="success" message={Translate('You have successfully created a new account.')} />
        </div>
        <div style={{ marginTop: '20px' }}>
          {Translate('Now you can go to ')} <Link to='/login'>{Translate('Login')}</Link>.
        </div>
      </>

    const successRegistrationWithEmailHtml =
      <>
        <div>
          <GrowlContent variant="success" message={Translate('You have successfully created a new account.')} />
        </div>
        <div style={{ marginTop: '20px' }}>
          {Translate('Check your E-mail box to confirm registration and activate your account.')}
        </div>
      </>

    const validConfirmCodeHtml =
      <>
        <div>
          <GrowlContent variant="success" message={Translate('You have successfully activated your account.')} />
        </div>
        <div style={{ marginTop: '20px' }}>
          {Translate('Now you can go to ')} <Link to='/login'>{Translate('Login')}</Link>.
        </div>
      </>

    const notValidConfirmCodeHtml =
      <>
        <div>
          <GrowlContent variant="error" message={Translate('4005')} />
        </div>
      </>

    let resultHtml;

    switch (mode) {
      case 'successRegistration':
        resultHtml = successRegistrationHtml;
        break;
      case 'successRegistrationWithEmail':
        resultHtml = successRegistrationWithEmailHtml;
        break;
      case 'validConfirmCode':
        resultHtml = validConfirmCodeHtml;
        break;
      case 'notValidConfirmCode':
        resultHtml = notValidConfirmCodeHtml;
        break;
      default:
        resultHtml = registrationFormHtml;
    }

    return (
      <div className="app-content">

        {isLoading ? <Spinner /> : null}
        <Growl ref={(el) => this.growl = el} />

        <h1>{Translate('Create a New Account')}</h1>

        <div>
          {resultHtml}
        </div>
      </div>
    )
  }
}

export default CreateNewAccountComponent;